module.exports = __webpack_public_path__ + "static/media/farm_pharm_9.a9944c41.jpg";